/**
 * Get the current time at a given location
 * @param location - The location to get the current time for
 * @returns The current time at the given location
 */
export async function getCurrentTimeAtLocation(location: { latitude: number; longitude: number }) {
	const response = await fetch(`/api/time?lat=${location.latitude}&lng=${location.longitude}`)
	const data = await response.json()
	return new Date(data.time)
}
